<template>
    <div class="empresaAgendaViewer">

        <b-card no-body>

            <div class="header-content row" slot="header">
                <div class="title col">
                    <strong>Detalles</strong>
                </div>
                <div class="diasLonchera col-tight row">
                    <div class="dia col"><span>L</span></div>
                    <div class="dia col"><span>M</span></div>
                    <div class="dia col"><span>I</span></div>
                    <div class="dia col"><span>J</span></div>
                    <div class="dia col"><span>V</span></div>
                    <div class="dia col">
                        <strong>Total</strong>
                    </div>
                </div>
            </div>

            <div class="content">
                <b-row class="alumno-row m0" v-for="alumno in alumnos" :key="'alumno-' + alumno.id" align-h="end" align-v="center" no-gutters>
                    
                    <b-col class="alumno pr-2">

                        <strong>
                            {{ alumno.nombre || loncheraSinNombre }}
                            <b-badge pill v-if="alumno.membresia == 'VIP'" variant="warning">VIP</b-badge>
                        </strong>

                        <div class="block">
                            <b-badge class="ml-1 mr-1" pill variant="dark" title="Codigo de registro"
                                v-if="alumno.codigo_registro" v-b-tooltip.hover.bottom>{{ alumno.codigo_registro
                                }}</b-badge>
                            <b-badge class="ml-1 mr-1" pill variant="danger" title="Adeudo"
                                v-if="parseFloat(alumno.monedero) < 0" v-b-tooltip.hover.bottom>{{
                                    Math.abs(alumno.monedero) | currency }}</b-badge>
                        </div>

                        <div class="block">
                            <div class="notas_alimentarias" v-if="alumno.notas_alimentarias">
                                <small>{{ alumno.notas_alimentarias }}</small>
                            </div>
                        </div>

                        <!-- <br> <small>{{alumno.tipo}}</small> -->

                    </b-col>

                    <b-col cols="auto" class="text-right hide-on-print">
                        <b-button-group size="sm">

                            <b-button variant="primary"
                                @click="$refs.loncheraDetalleEntrega.open(alumno.id, selectFilters.fechas.inicio, selectFilters.fechas.fin)">
                                <i class="fa fa-block fa-info"></i>
                            </b-button>

                            <usuario-modal :concept-id="alumno.usuario_id_pk" btn-class="btn btn-secondary"
                                @refresh="$emit('forceUpdate')">
                                <i class="fa fa-user"></i> Usuario
                            </usuario-modal>

                        </b-button-group>
                    </b-col>

                    <b-col cols="auto" class="dias">
                        <dias-lonchera :edit-mode="editMode" :u-presencia-id="alumno.id"
                            :fechas="filterFechas(alumno.id)" 
                            :modo-agenda="sedeHeader.modo_agenda" 
                            :debug="debug"
                            :select-filters="selectFilters" 
                            @reload="$emit('reload')" />
                    </b-col>

                </b-row>
            </div>

            <div class="totals">
                <b-row class="m0" align-h="end" align-v="center" no-gutters>

                    <b-col cols="auto" class="alumno">
                        <strong>Totales</strong>
                    </b-col>

                    <b-col cols="auto" class="dias">
                        <dias-lonchera :fechas="filterFechasAlumnos" totalizer :debug="debug" @reload="$emit('reload')" />
                    </b-col>

                </b-row>
            </div>

            <div class="debug" v-if="debug">
                alumnado
                <pre>{{ alumnos }}</pre>
            </div>
        </b-card>

        <ModalEasylunchEntregaDetalle ref="loncheraDetalleEntrega"></ModalEasylunchEntregaDetalle>

    </div>
</template>

<script>
import ModalEasylunchEntregaDetalle from '../elements/modalEasylunchEntregaDetalle'
import _ from 'lodash'
import usuarioModal from '../../Usuarios/assets/usuarioModal.vue'
import diasLonchera from './diasLonchera.vue'
import { loncheraSinNombre } from '../Easylunch'

export default {

    name: 'empresaAgendaViewer',

    components: {
        ModalEasylunchEntregaDetalle, diasLonchera, usuarioModal
    },

    props: {
        selectFilters: {
            type: Object
        },
        editMode: {
            type: Boolean
        },
        filterBy: {
            type: [String],
            required: true
        },
        debug: {
            type: [Boolean, Number],
            default: false
        },
        getData: {
            type: Function,
            required: true
        }
    },

    data: () => {
        return {
            loncheraSinNombre,
            data: {
                headers: [],
                groups: [],
                alumnos: [],
                agendaordenes: [],
            },
            alumnos: []
        }
    },

    computed: {
        sedeHeader() {
            try {
                let found = _.find(this.data.headers, { id: this.selectFilters.cede_id })
                if (!found)
                    throw 'Sede no encontrada';
                return found;
            } catch (e) {
                console.error(e)
                return null;
            }
        },
        filterFechasAlumnos() {
            return _.filter(this.data.agendaordenes, (aOrd) => {
                let indexOfAOrd = _.findIndex(this.alumnos, { id: aOrd.lunch_usuariopresencia_id });
                return (indexOfAOrd !== -1)
            })
        },
    },

    methods: {
        filterFechas(alumnoId) {
            return _.filter(this.data.agendaordenes, {
                lunch_usuariopresencia_id: alumnoId
            })
        }
    },

    beforeMount() {
        this.data = this.getData()
        this.alumnos = _.filter(this.data.alumnos, {
            tipo: this.filterBy
        })
    }

}
</script>

<style lang="less">
.empresaAgendaViewer {

    .row {
        margin: 0;
    }

    .col {
        align-content: center;
    }

    .card-header {
        margin: 0;
        padding: 0;
    }

    .totals {
        color: var(--primary);
        border-top: 1px solid #c8ced3;
        background-color: #f0f3f5;
    }

    .alumno-row {
        padding: 0em 0;
        background-color: #f6f6f6;

        &:nth-child(2n+1) {
            background-color: #fff;
        }

        .alumno {
            text-align: right;
            text-transform: uppercase;
            color: #696969;
            display: inline;
            // background: green;
        }
    }
}
</style>